import React from 'react';
import '../styles/TermsOfService.css';

const TermsOfService = () => {
  return (
    <main className="terms-container">
      <h1>Terms Of Service</h1>
      <p>Effective Date: 26th December 2024</p>
      <p>
        Welcome to Rice Reviews (the "App"). By accessing or using the App, you
        agree to be bound by these Terms of Service ("Terms"). If you do not
        agree to these Terms, please do not use the App.
      </p>
      <h2>1. Use of the App</h2>
      <p>
        <strong>1.1 Eligibility:</strong> You must be at least 13 years old to
        use the App. By using the App, you represent that you meet this
        requirement.
      </p>
      <p>
        <strong>1.2 Account Registration:</strong> To access certain features,
        you may be required to create an account. You are responsible for
        maintaining the confidentiality of your account information.
      </p>
      <p>
        <strong>1.3 Permitted Use:</strong> You may use the App only for lawful
        purposes and in accordance with these Terms.
      </p>
      <h2>2. Content</h2>
      <p>
        <strong>2.1 User-Generated Content:</strong> The App allows users to
        upload reviews and other content ("User Content"). You grant us a
        license to use, reproduce, modify, display, and distribute your content.
      </p>
      <p>
        <strong>2.2 Responsibility for Content:</strong> You are solely
        responsible for the User Content you upload.
      </p>
      <h2>3. Location Services</h2>
      <p>
        The App uses location services to recommend nearby restaurants. You can
        disable location services in your device settings.
      </p>
      <h2>4. Intellectual Property</h2>
      <p>
        <strong>4.1 Ownership:</strong> The App and its content (excluding User
        Content) are owned by Rice Reviews LLC.
      </p>
      <p>
        <strong>4.2 Restrictions:</strong> You may not copy, modify, or
        distribute any part of the App.
      </p>
      <h2>5. Third-Party Links and Services</h2>
      <p>
        The App may include links to third-party websites or services. We are
        not responsible for the content or practices of these third parties.
      </p>
      <h2>6. Termination</h2>
      <p>
        We may suspend or terminate your access to the App at any time for any
        reason.
      </p>
      <h2>7. Disclaimer of Warranties</h2>
      <p>
        The App is provided "as is" without warranties of any kind, either
        express or implied.
      </p>
      <h2>8. Limitation of Liability</h2>
      <p>
        We are not liable for indirect, incidental, or consequential damages
        arising from your use of the App.
      </p>
      <h2>9. Indemnification</h2>
      <p>
        You agree to indemnify and hold Rice Reviews LLC harmless from claims or
        damages.
      </p>
      <h2>10. Governing Law</h2>
      <p>
        These Terms are governed by and construed in accordance with the laws of
        the State of New York, United States, without regard to its conflict of
        law provisions. You agree to submit to the exclusive jurisdiction of the
        courts located in New York County, New York, for the resolution of any
        disputes arising out of or relating to these Terms or the use of the
        App.
      </p>
      <h2>11. Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. Your continued use of the
        App constitutes acceptance of the revised Terms.
      </p>
      <h2>12. Contact Us</h2>
      <p>
        If you have questions, contact us at:
        <br />
        Rice Reviews LLC
        <br />
        800 N King Street Suite 304 2918 Wilmington, DE 19801 United States
        <br />
        Email: contact@ricereviews.com
      </p>
      <p>By using the App, you agree to these Terms of Service.</p>
    </main>
  );
};

export default TermsOfService;
